<template>
  <div>
    <div id="global-flow-css"></div>
    <div class="min-vh-100">
      <div id="header"></div>
      <router-view v-slot="{ Component }">
        <transition :name="transition" mode="out-in">
          <keep-alive>
            <component :is="Component" :key="$route.fullPath"></component>
          </keep-alive>
        </transition>
      </router-view>
    </div>
    <div id="footer"></div>
  </div>
</template>
<script>
import "vue-code-highlight/themes/window.css"
export default {
  name: 'App',
  data(){
   return {
     transition: 'slide',
   }
  },
  methods:{},
  provide() {
    return {
      setTransition: (t = 'slide') => {
        if(this.transition === 'disabled'){
          return
        }
        this.transition = t
      },
    }
  },
  mounted() {
    const header = document.querySelector('#header')
    const footer = document.querySelector('#footer')
    const globalCSS = document.querySelector('#global-flow-css')

    const currentPath = () => window.location.pathname

    const observerSetup = (target, singleEl =true) => {
      const observer = new MutationObserver((mutations) => {
        observer.disconnect() // disconnect to avoid infinite loop

        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const path = currentPath()

              const clone = node.cloneNode(true)
              clone.setAttribute('data-cloned-from-path', path)

              if( singleEl ) target.innerHTML = '';
              target.appendChild(clone)

              node.remove()
            }
          }
        }

        observer.observe(target, { childList: true }) // reconnect observer
      })

      return observer
    }

    const headerObserver = observerSetup(header)
    const footerObserver = observerSetup(footer)
    const globalCSSObserver = observerSetup(globalCSS)

    headerObserver.observe(header, { childList: true })
    footerObserver.observe(footer, { childList: true })
    globalCSSObserver.observe(globalCSS, { childList: true })

    this.$nextTick(() => {
      cleanupTarget(globalCSS)
    })

    this.$watch('$route.fullPath', () => {
      setTimeout(() => {
        cleanupTarget(globalCSS)
      }, 1000)
    })

    function cleanupTarget(target) {
      const teleported = Array.from(target.children)?.filter(el =>
          el.hasAttribute('data-v-teleport') // detect Vue-teleported nodes
      )

      if (teleported.length > 0) {
        const latest = teleported[teleported.length - 1]
        const clone = latest.cloneNode(true)
        clone.setAttribute('data-cloned-from-path', currentPath())

        target.innerHTML = ''
        target.appendChild(clone)
      }
    }

    window.addEventListener('beforeunload', () => {
      if(sessionStorage.getItem('waffle_tab')){
        if(window.channel){
          window.channel.postMessage({type:'TAB_UNLOADED'})
        }
      }
    })
  }
}
</script>
<style lang="scss" src="@/assets/scss/waffle.scss">
</style>
<style>
  .slide-enter-active,
  .slide-leave-active,
  .slide-back-enter-active,
  .slide-back-leave-active{
    transition: opacity .5s, transform .5s;
  }

  .slide-enter-active .waffle.modal,
  .slide-leave-active .waffle.modal,
  .slide-back-enter-active .waffle.modal,
  .slide-back-leave-active .waffle.modal {
    display: none !important;
  }

  .slide-enter-from{
    opacity: .5;
    transform: translateX(30%);
  }
  .slide-leave-to,
  .slide-back-enter-from{
    opacity: .5;
    transform: translateX(-30%);
  }

  .slide-back-leave-to {
    opacity: .5;
    transform: translateX(30%);
  }
  pre {
    background-image: none !important;
  }
</style>